import { combineReducers } from '@reduxjs/toolkit';

import sessionReducer from './session';
import adminSessionReducer from './adminSession';

const reducer = combineReducers({
  session: sessionReducer,
  adminSession: adminSessionReducer,
});

export default reducer;
